import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
} from '@chakra-ui/react';
import DrawerHeaderBar from 'components/DrawerHeaderBar';

/**
 * A styled drawer component that matches the design system.
 * Slides up from the bottom with rounded corners, a header with close button,
 * and a body area for content.
 */
const MMDrawer = ({
  isOpen,
  onClose,
  title,
  headerLeft,
  hideHeader = false,
  closeAction = 'dismiss',
  children,
}) => {
  const closeAriaLabel = closeAction === 'back' ? 'Back' : 'Close';

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="bottom" size="full">
      <DrawerOverlay />
      <DrawerContent
        mt="0.5rem"
        borderTopRadius="0.375rem"
        maxH="calc(100vh - 0.5rem)"
      >
        {!hideHeader && (
          <DrawerHeaderBar
            title={title}
            onClose={onClose}
            headerLeft={headerLeft}
            closeAriaLabel={closeAriaLabel}
          />
        )}
        <DrawerBody
          p={0}
          display="flex"
          flexDirection="column"
          position="relative"
        >
          {children}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

MMDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerLeft: PropTypes.node,
  hideHeader: PropTypes.bool,
  closeAction: PropTypes.oneOf(['dismiss', 'back']),
  children: PropTypes.node,
};

export default MMDrawer;
